import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  ColorLockEventInfo,
  GameInfo,
  PhaseType,
  SessionInfo,
} from "../.././common/Info";
import { youLoggedOut } from "./profileSlice";
import { setSession } from "../actions";

const initialState: GameInfo = {
  id: "",
  currentPlayerIndex: 0,
  currentTurn: 0,
  dice: undefined,
  phase: PhaseType.dice,
  redLocked: false,
  yellowLocked: false,
  blueLocked: false,
  greenLocked: false,
};

const gameSlice = createSlice({
  name: "game",
  initialState,
  reducers: {
    startGame(state, action: PayloadAction<SessionInfo>) {
      return action.payload.game;
    },
    setGame(state, action: PayloadAction<GameInfo>) {
      return action.payload;
    },
    playerPassed(state, action: PayloadAction<SessionInfo>) {
      return action.payload.game;
    },
    diceRolled(state, action: PayloadAction<SessionInfo>) {
      return action.payload.game;
    },
    turnAdvanced(state, action: PayloadAction<SessionInfo>) {
      return action.payload.game;
    },
    phaseAdvanced(state, action: PayloadAction<SessionInfo>) {
      return action.payload.game;
    },
    gameEnded(state, action: PayloadAction<SessionInfo>) {
      return action.payload.game;
    },
    colorLocked(state, action: PayloadAction<ColorLockEventInfo>) {
      return action.payload.session.game;
    },
  },
  extraReducers(builder) {
    builder.addCase(setSession, (state, action: PayloadAction<SessionInfo>) => {
      return action.payload.game;
    });
    builder.addCase(youLoggedOut, () => {
      return initialState;
    });
  },
});

export const {
  setGame,
  startGame,
  playerPassed,
  diceRolled,
  turnAdvanced,
  phaseAdvanced,
  gameEnded,
  colorLocked,
} = gameSlice.actions;
export const gameReducer = gameSlice.reducer;
